import React from "react";
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider'
import MUIDataTable from 'mui-datatables';
import styled from 'styled-components'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  LinearProgress,
  TextField,
  Button,
  Snackbar,
  Alert,
  InputLabel,
  IconButton,
  Collapse
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useLazyGetMinutesQuery, useDeleteIssuesMutation, usePostPredictMutation } from '../../services/mqlAPI'
import "./ListPage.module.scss"
import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

const Title = styled.p`
  font-size: 20px;
  color: #666666;
  font-weight: bold;
  margin-top: 1px;
  margin-bottom: 2px;
  margin-left: 20px;
  text-align: left;
`
const TextInput = styled(TextField)`
  width: 100%;
`

const ButtonDiv = styled.div`
  margin-top: 55px;
  margin-left: 100px;
`

const DeleteModalDiv = styled.div`
  margin-top: 50px;
  margin-left: 0px;
`

const CustomButton = styled(Button)`
  width: 90px;
  `

const DeleteCustomButton = styled(Button)`
  width: 120px;
  `

const TableDiv = styled.div`
  margin-top: 20px;
  margin-right: 2px;
  margin-left: 2px;
  `

const DeleteBoxStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 10,
  p: 4,
}

const PredictBoxStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  height: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 10,
  p: 4,
}

type ErrorResponse = {
  detail_msg: string | null;
  code: number | null;
}

export type Minute = {
  minute_id: string;
  minutes_original: string;
  analysis_status: string;
  analysis_timestamp: number;
  company_name: string;
  source: string;
  issue_list: Issues[];
  issue_count: number;
}
export type Issues = {
  issue_id: string;
  extract_issue: string;
  core_issue: string;
  status: string;
}

const ListPage = (): JSX.Element => {
  const [search, setSearch] = useState('');
  const [getMinutes, { data: getMinutesData, error: getMinutesError, isFetching: getMinutesFetching }] = useLazyGetMinutesQuery()
  const [deleteIssues, { data: deleteIssuesData, error: deleteIssuesError, isSuccess: deleteIssuesSuccess, reset: deleteIssuesReset }] = useDeleteIssuesMutation()
  const [postPredict, { data: postPredictData, error: postPredictError, reset: postPredictReset }] = usePostPredictMutation()
  const [open, setOpen] = React.useState(false);
  const handleOpen = (id: string) => {
    setOpen(true);
    setId(id)
  }
  const handleClose = () => setOpen(false);
  const [predictOpen, setPredictOpen] = React.useState(false);
  const handlePredictOpen = () => {
    setPredictOpen(true);
  }
  const handlePredictClose = () => setPredictOpen(false);
  const [id, setId] = useState('');
  const [disabledDeleteButton, setDisabledDeleteButton] = React.useState(true);

  //分析実行用
  const [content, setContent] = useState<string>('');
  const [company_name, setCompanyName] = useState<string | null>('');
  const [source, setSource] = useState<string | null>('');

  // バリデーション用のステート
  const [searchError, setSearchError] = useState(false);

  // snackbar表示用
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const errorHandleClose = () => { setErrorOpen(false) };
  const infoHandleClose = () => { setInfoOpen(false) };
  const [errMessage, setErrMessage] = useState<string | null>(null);
  const [infoMessage, setInfoMessage] = useState<string | null>(null);

  // Login属性情報
  // const { user: LoginUser, signOut: LoginSignOut } = useAuthenticator((context) => [context.user]);


  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  useEffect(() => {
    if (getMinutesFetching === false) {
      // フェッチ後のトースト表示設定
      if (getMinutesError) {
        let errMsg = ""
        if ('status' in getMinutesError) {
          // FetchBaseQueryError
          const data = (getMinutesError.data as ErrorResponse)
          errMsg = data?.detail_msg ?? "検索に失敗しました。"
        } else {
          // SerializedError
          errMsg = getMinutesError.message ?? "検索に失敗しました。"
        }
        setErrorOpen(true)
        setErrMessage(errMsg)
      }
      else if (deleteIssuesError) {
        let errMsg = ""
        if ('status' in deleteIssuesError) {
          // FetchBaseQueryError
          errMsg = "メモの削除に失敗しました。"
        } else {
          // SerializedError
          errMsg = "メモの削除に失敗しました。"
        }
        setErrorOpen(true)
        setErrMessage(errMsg)
      }
      else if (getMinutesData?.minutes_list?.length === 0) {
        const infoMsg = "検索結果が0件でした。"
        setInfoMessage(infoMsg)
        setInfoOpen(true)
      }
      else if (deleteIssuesSuccess) {
        const infoMsg = "メモを削除しました。"
        setInfoMessage(infoMsg)
        setInfoOpen(true)
        setDisabledDeleteButton(true)
      }
      else if (!deleteIssuesSuccess) {
        setDisabledDeleteButton(false)
      }
    }
  }, [getMinutesError, getMinutesData, getMinutesFetching, deleteIssuesData, deleteIssuesError, deleteIssuesSuccess, deleteIssuesReset])

  const transformedData: Minute[] = Array.isArray(getMinutesData) ? getMinutesData : [];

  useEffect(() => {
    getMinutes(search)
  }, [])

  const handlePersonaButtonClick = (minute_id?:string, id?: string, issue?: string) => {
    const encodedMinuteId = minute_id ? encodeURIComponent(minute_id) : "";
    const encodedId = id ? encodeURIComponent(id) : "";
    const encodedIssue = issue ? encodeURIComponent(issue) : "";
    const url = `/create?minute_id=${encodedMinuteId}&id=${encodedId}&issue=${encodedIssue}`;
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        newWindow.document.title = 'ペルソナ推定/' + (issue || "");
      };
    }
  };

  
  const handleButtonClick = (dataIndex: number) => {
    const currentExpandedRows = [...expandedRows];
    const isRowCurrentlyExpanded = currentExpandedRows.includes(dataIndex);
    
    const newExpandedRows = isRowCurrentlyExpanded
    ? currentExpandedRows.filter(id => id !== dataIndex)
    : currentExpandedRows.concat(dataIndex);
    
    setExpandedRows(newExpandedRows);
  };

  // 議事録原文省略表示用
  const [isExpanded, setIsExpanded] = useState<number[]>([]);
  const handleTextClick = (rowIndex: number) => {
    const currentExpanded = [...isExpanded];
    const isRowCurrentlyExpanded = currentExpanded.includes(rowIndex);
    
    const newExpanded = isRowCurrentlyExpanded
    ? currentExpanded.filter(id => id !== rowIndex)
    : currentExpanded.concat(rowIndex);
    
    setIsExpanded(newExpanded);
  };


  // 折りたたみテーブルの展開ボタン実装によりヘッダーと値が一つずれて表示される
  const columns = [  
    {
      name: "minute_id",
      label: "No.",
      options: {
        serverSide: false,
        customBodyRender: (value:any, tableMeta: any) => {
          const rowIndex = tableMeta.rowIndex;
          const isExpandedText = isExpanded.includes(rowIndex);
          const maxLength = 20; // 最大文字数
          return (
            <div onClick={() => handleTextClick(rowIndex)} style={{ cursor: "pointer" }}>
              {isExpandedText ? tableMeta.rowData[1] : tableMeta.rowData[1].length > maxLength ? `${tableMeta.rowData[1].substring(0, maxLength)}...` : tableMeta.rowData[1]}
            </div>
          );
        }  
      },
    },
    {
      name: "minutes_original",
      label: "議事録原文",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            tableMeta.rowData[2]
          );
        }
      }
    },
    {
      name: "company_name",
      label: "顧客名",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            tableMeta.rowData[3]
          );
        }
      }
    },
    {
      name: "source",
      label: "情報ソース",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            tableMeta.rowData[4]
          );
        }
      }
    },
    {
      name: "issue_count",
      label: "課題数",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            tableMeta.rowData[5]
          );
        }
      },
    },
    {
      name: "analysis_status",
      label: "分析状態",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            toISOStringWithTimezone(new Date(tableMeta.rowData[6] * 1000))
          );
        }
      },
    },
    {
      name: "analysis_timestamp",
      label: "分析時間",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <Stack spacing={2}>
              <CustomButton
                variant="contained"
                color="error"
                onClick={() => {
                  handleOpen(tableMeta.rowData[0])
                }}
              >
                削除
              </CustomButton>
              <Modal
                open={open}
                onClose={() => {
                  handleClose()
                  handleSubmit()
                  deleteIssuesReset()
                }}
                sx={{
                  '& .MuiModal-backdrop': {
                    backgroundColor: 'rgba(255, 255, 255, 0.05);',
                  }
                }}
              >
                <Box sx={DeleteBoxStyle}>
                  <Typography>
                    <span>選択した項目を本当に削除しますか？<br />削除後は復元できません。</span>
                  </Typography>
                  <DeleteModalDiv>
                    <Stack
                      direction="row"
                      spacing={5}
                      justifyContent="center"
                    >
                      <DeleteCustomButton
                        variant="contained"
                        onClick={() => {
                          handleDelete(id)
                          handleClose()
                          handleSubmit()
                        }}
                        disabled={disabledDeleteButton}
                      >
                        削除
                      </DeleteCustomButton>
                      <DeleteCustomButton
                        variant="contained"
                        onClick={() => {
                          handleClose()
                          handleSubmit()
                          deleteIssuesReset()
                        }}
                      >
                        キャンセル
                      </DeleteCustomButton>
                    </Stack>
                  </DeleteModalDiv>
                </Box>
              </Modal>
            </Stack>
          );
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        sort: false,
        empty: false,
       
      }
    },
  ]

  const options= {
    // 高さ指定
    tableBodyHeight: "650px",
  
    // 最終更新日時でソート
    sortOrder: { name: "analysis_timestamp" as any, direction: "desc" as any },
  
    // 列選択のcheckboxを表示しない
    selectableRows: false as any,
    filter: false,
    search: true,
    print: false,
    download: false,
    viewColumns: false,

    serverSide: false, // これを追加
    onSearchChange: (searchText:any) => {
      console.log("search: " + searchText);
    },

    selectableRowsOnClick: true,
  
    rowsPerPage: 100,
    rowsPerPageOptions: [],
    textLabels: {
      body: {
        noMatch: `表示できるデータが存在しません`,
      }
    },
    customRowRender: (data: any[], dataIndex: number, rowIndex: number) => {
      return (
        <>
          <TableRow>
            <TableCell>
              <IconButton onClick={() => handleButtonClick(dataIndex)}>
                {expandedRows.includes(dataIndex) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
              <span>{rowIndex+1}</span>
            </TableCell>
            {data.map((cell, index) => (
              <TableCell key={index}>{cell}</TableCell>
            ))}
          </TableRow>
          {expandedRows.includes(dataIndex) && (
            <TableRow>
              <TableCell colSpan={columns.length}>
                <Collapse in={expandedRows.includes(dataIndex)} timeout="auto" unmountOnExit>
                  <Box margin={1}>
                    {transformedData[dataIndex] && <ExpandedTable issues={transformedData[dataIndex].issue_list} minute_id={transformedData[dataIndex].minute_id}  rowIndex={rowIndex}/>}
                    </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          )}
        </>
      );
    }
  }

  const ExpandedTable = ({ issues, minute_id, rowIndex }: { issues: Issues[], minute_id: string, rowIndex: number }) => {
    return (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No.</TableCell>
                <TableCell>抽出課題</TableCell>
                <TableCell>本質課題</TableCell>
                <TableCell>分析状態</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                {issues.map((issues, index) => {
                  return (
                  <TableRow key={issues.issue_id}>
                    <TableCell>{index+1}</TableCell>
                    <TableCell>{issues.extract_issue}</TableCell>
                    <TableCell>{issues.core_issue}</TableCell>
                    <TableCell>{issues.status}</TableCell>
                    <TableCell>
                    <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handlePersonaButtonClick(minute_id, issues.issue_id, issues.core_issue)
                      handleClose()}
                    }
                    disabled={issues.status !== "分析完了"}
                  >
                    詳細
                </CustomButton>
                    </TableCell>
                  </TableRow>
                )})}
            </TableBody>
          </Table>
    )
  };
  

  function toISOStringWithTimezone(date: Date): string {
    const pad = function (str: string): string {
      return ('0' + str).slice(-2);
    }
    const year = (date.getFullYear()).toString();
    const month = pad((date.getMonth() + 1).toString());
    const day = pad(date.getDate().toString());
    const hour = pad(date.getHours().toString());
    const minute = pad(date.getMinutes().toString());
    return `${year}/${month}/${day} ${hour}:${minute}`;
  }


  const handleSubmit = () => {
    getMinutes(search)
  };

  const handleDelete = (id: string) => {
    deleteIssues(id)
  }

  const handlePredict = () => {
    const formData = {
      content,
      company_name,
      source
    };
    let errMsg = ""
    const fetchData = async () => {
      try {
        const response = await postPredict(formData);
        if ('error' in response) {
          if ('status' in response.error) {
            switch (response.error.status) {
              case 400:
                errMsg = "エラーが発生しました。議事録が未記入か容量をオーバーしています。"
                setErrorOpen(true)
                setErrMessage(errMsg)
                console.error('400エラー:',response)
                break;
              default:
                errMsg = "エラーが発生しました。"
                setErrorOpen(true)
                setErrMessage(errMsg)
                console.error('予期せぬエラーが発生しました:',response)
            }
          }
        }
      } catch (error) {
        errMsg = "予期せぬエラーが発生しました。"
        setErrorOpen(true)
        setErrMessage(errMsg)
        console.error('予期せぬエラーが発生しました:', error);
      }
    };
    
    // 分析実行
    fetchData();
  }


  return (
    <Box sx={{ whiteSpace: 'pre-line' }}>
      <Grid container>
        <Grid item xs={11}>
          <Title>MQL抽出サポートシステム</Title>
        </Grid>
        <Grid item xs={1}>
        </Grid>
      </Grid>
      <Divider variant="middle" />
      <Grid container>
        <Grid item xs={1}>
          <ButtonDiv>
              <Button
                disabled={getMinutesFetching}
                variant="contained"
                sx={{ whiteSpace: 'nowrap' }}
                onClick={() => {
                  handlePredictOpen()
                }}
              >
                新規分析
              </Button>
              <Modal
                open={predictOpen}
                onClose={() => {
                  handleClose()
                  handleSubmit()
                  deleteIssuesReset()
                }}
                sx={{
                  '& .MuiModal-backdrop': {
                    backgroundColor: 'rgba(255, 255, 255, 0.05);',
                  }
                }}
              >
                <Box sx={PredictBoxStyle}>
                <Title>新規分析</Title>
                  <InputLabel style={{ top: '8px' }}>議事録</InputLabel>
                  <TextInput
                    type="text"
                    // style={{ height: 100, padding: 10}}
                    value={content}
                    // error={company_nameError}
                    onChange={inputContentName => {
                      setContent(inputContentName.target.value)
                    }}
                    margin="dense"
                    multiline
                    rows={7}
                  />
                  <InputLabel style={{ top: '8px' }}>顧客名</InputLabel>
                  <TextInput
                    type="text"
                    size="small"
                    value={company_name}
                    // error={company_nameError}
                    onChange={inputCompanyName => {
                      setCompanyName(inputCompanyName.target.value)
                    }}
                    margin="dense"
                  />
                  <InputLabel style={{ top: '8px' }}>情報ソース</InputLabel>
                  <TextInput
                    type="text"
                    size="small"
                    value={source}
                    // error={company_nameError}
                    onChange={inputSourceName => {
                      setSource(inputSourceName.target.value)
                    }}
                    margin="dense"
                  />
                  <Stack
                    direction="row"
                    spacing={5}
                    justifyContent="center"
                  >
                    <DeleteCustomButton
                      variant="contained"
                      onClick={() => {
                        handlePredict()
                        handlePredictClose()
                        handleSubmit()
                      }}
                      disabled={disabledDeleteButton}
                    >
                      実行
                    </DeleteCustomButton>
                    <DeleteCustomButton
                      variant="contained"
                      onClick={() => {
                        handlePredictClose()
                      }}
                    >
                      キャンセル
                    </DeleteCustomButton>
                  </Stack>                  
                </Box>
              </Modal>
          </ButtonDiv>
        </Grid>
      </Grid>

      <TableDiv>
        {getMinutesFetching && <LinearProgress />}
        {getMinutesData && (
          <MUIDataTable
            title=""
            data={transformedData}
            columns={columns}
            options={options}
          />
        )}
      </TableDiv>

      <Snackbar
        open={errorOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={errorHandleClose}
      >
        <Alert
          onClose={errorHandleClose}
          severity="error"
          sx={{ width: '100%' }}
        >
          {errMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={infoOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={infoHandleClose}
      >
        <Alert
          onClose={infoHandleClose}
          severity="info"
          sx={{ width: '100%' }}
        >
          {infoMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ListPage;